var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"message"},[_vm._v("This layout has no pages generated yet.")])
}
var staticRenderFns = []

export { render, staticRenderFns }